<template lang="pug">
.draggable-files(v-show="0 < _value.length" :style="{ width: itemWidth, maxWidth: itemWidth }")
  .register-group
    draggable.draggable(v-model="_value" animation="200" ghostClass="ghost" @start="onDragStart(true)" @end="onDragEnd(false)")
      .register-value(v-for="(file, index) in _value" :key="file.key")
        .file(:id="popoverPrefix + '_file_' + index" :class="{ grabbing : isGrabbing }" :style="{ width: itemWidth, maxWidth: itemWidth }")
          .d-flex.justify-content-start.align-items-stretch
            .d-inline-flex.align-items-center(:style="{ minWidth: itemWidth, width: itemWidth, maxWidth: itemWidth }")
              span.file-index {{ index + 1 }}.
              span.file-name.text-truncate(:style="{ width: _calcFileNameWidth }") {{ file.name }}
            .d-inline-flex.align-items-center.justify-content-end
              button.trash-btn.btn(@click="onDelete(index)")
                .trash-icon
        b-popover(ref="popovers" :target="popoverPrefix + '_file_' + index" placement="lefttop" triggers="hover" :disabled="isGrabbing") {{ file.name }}
    span.comment ※ドラッグ＆ドロップでファイルの並び替えが可能です
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import draggable from "vuedraggable";
import DraggableFile from "@/commons/models/DraggableFile";

/**
 * ### ドラッグ&ドロップ可能なファイルリスト
 *
 * - ファイルを一覧表示する
 * - ドラッグ&ドロップでファイルの並び替えを行う
 */
@Component({
  components: {
    draggable
  }
})
export default class DraggableFiles extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ type: Array, required: false, default: null })
  value!: Array<DraggableFile>;
  /** ドラッグ対象の横幅 */
  @Prop({ type: String })
  itemWidth!: string;
  @Prop({ default: "" })
  popoverPrefix!: string;

  /** ドラッグされているかの状態 */
  isGrabbing: boolean = false;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): Array<DraggableFile> {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(value: Array<DraggableFile>) {
    this.inputValue(value);

    return;
  }

  /**
   * ### ファイルがドラッグ開始されたイベント処理
   *
   * - vuedraggableの挙動により、ドラッグでファイルを入れ替えるとhover対象の要素がズレる
   *   そのため、ドラッグ中はhoverのスタイルを無効にする
   *   - スタイルのon/offを切り替えるためにドラッグ状態を切り替える
   * - vuebootstrapのpopoverもズレるので、ドラッグ中は非表示にする
   */
  private onDragStart(grabbing: boolean) {
    this.isGrabbing = grabbing;

    if (grabbing) {
      const popovers: any = this.$refs.popovers;
      for (let i = 0; i < popovers.length; i++) {
        popovers[i].$emit("close");
      }
    }

    return;
  }

  /**
   * ### ファイルがドラッグ終了したイベント処理
   *
   * - スタイルのon/offを切り替えるためにドラッグ状態を切り替える
   */
  private onDragEnd(grabbing: boolean) {
    this.isGrabbing = grabbing;

    return;
  }

  /**
   * 選択されたファイルを親コンポーネントに返す
   */
  private inputValue(value: Array<DraggableFile>): void {
    this.$emit("input", value);

    return;
  }

  /**
   * ### 削除ボタンが押下された位置を親コンポーネントに返す
   */
  private onDelete(index: number) {
    this.$emit("delete", index);

    return;
  }

  get _calcFileNameWidth(): string {
    return this.itemWidth ? `calc(100% - 84px)` : "";
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";
.draggable-files {
  .draggable {
    margin-bottom: 8px;
    width: 100%;
    .file {
      position: relative;

      &:hover {
        cursor: grab;
        background-color: $btn-draggable-hover !important;
        transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
      }

      display: inline-block;
      padding: 8px;
      @include font(16px);
      margin: 0 8px 4px 0;
      border-radius: 3px;
      transition: all 0.2s;
      border: 1px solid $form-border-color;
      max-width: 100%;

      .file-index {
        margin: 0 !important;
        font-weight: bold;
      }
      .file-name {
        margin: 0 0 0 8px !important;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .trash-btn {
        position: absolute;
        right: 8px;

        font-size: 16px !important;
        height: 32px !important;
        padding: 2px 5px !important;
      }
      .trash-icon {
        @include svg-icon("../../assets/trash.svg", $font-base-color, 24px, 24px);
      }
    }
    .grabbing {
      &:hover {
        background-color: #fff !important;
      }
    }
    .ghost {
      .file {
        cursor: grabbing;
        background-color: $btn-draggable-hover !important;
      }
    }
  }
  .comment {
    color: $validation-label-font-color;
  }
}
</style>
